// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import TwitterSquareFilledSvg from "@fishx/icons-svg/es/asn/TwitterSquareFilled";
import FishxIcon from '../components/FishxIcon';

var TwitterSquareFilled = function TwitterSquareFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: TwitterSquareFilledSvg
  }));
};

TwitterSquareFilled.displayName = 'TwitterSquareFilled';
export default React.forwardRef(TwitterSquareFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/TwitterSquareFilled.js
// module id = 4302
// module chunks = 0